var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0785 3.15698C7.15225 3.15698 3.15698 7.15225 3.15698 12.0785C3.15698 17.0048 7.15225 21.0001 12.0785 21.0001C17.0048 21.0001 21.0001 17.0048 21.0001 12.0785C21.0001 7.15225 17.0048 3.15698 12.0785 3.15698ZM16.2207 13.6717H11.7599C11.5085 13.6717 11.2621 13.5696 11.0828 13.3929C10.9061 13.2137 10.804 12.9672 10.804 12.7158V6.98051C10.804 6.45279 11.2322 6.02463 11.7599 6.02463C12.2876 6.02463 12.7158 6.45279 12.7158 6.98051V11.3207C12.7158 11.5633 12.9124 11.7599 13.155 11.7599H16.2207C16.7484 11.7599 17.1766 12.1881 17.1766 12.7158C17.1766 13.2435 16.7484 13.6717 16.2207 13.6717Z",
    fill: "#4A4A68"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.14b7cf38b30d62d44a8e64fb1fa51066.svg";
export { ForwardRef as ReactComponent };